import $ from 'jquery'
import selects from './selects'
import broker_calculator from './broker_calculator'
import plan_builder from './plan_builder'
import iframe from './iframe'
import modals from '../../cms/modules/modals'

const modules = [
    selects,
    broker_calculator,
    plan_builder,
    iframe,
    modals
]

$(() => {
    $(modules).each((index, module) => {
        module.init()
    })
})

window.onYouTubeIframeAPIReady = modals.onYoutubeVideoAPIReady